import React from 'react';
export class ProgressRing extends React.Component {
  constructor(props) {
    super(props);
    const {
      radius,
      stroke
    } = this.props;
    this.normalizedRadius = radius - stroke * 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
  }
  render() {
    const {
      radius,
      stroke,
      progress
    } = this.props;
    const strokeDashoffset = this.circumference - progress / 100 * this.circumference;
    const strokeColor = this.props.strokeColor ? this.props.strokeColor : '#2ED47A';
    return /*#__PURE__*/React.createElement("svg", {
      height: radius * 2,
      width: radius * 2
    }, /*#__PURE__*/React.createElement("circle", {
      stroke: strokeColor,
      fill: "transparent",
      strokeWidth: stroke,
      strokeDasharray: this.circumference + ' ' + this.circumference,
      style: {
        strokeDashoffset
      },
      r: this.normalizedRadius,
      cx: radius,
      cy: radius
    }));
  }
}
export class ProgressCircle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0
    };
  }
  componentDidMount() {
    // emulating progress
    const interval = setInterval(() => {
      this.setState({
        progress: this.state.progress + 10
      });
      if (this.state.progress === 100) clearInterval(interval);
    }, 50);
  }
  render() {
    return /*#__PURE__*/React.createElement(ProgressRing, {
      radius: 100,
      stroke: 6,
      progress: this.state.progress
    });
  }
}
export default class ProgressSuccess extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "progress-success-box"
    }, /*#__PURE__*/React.createElement("div", {
      className: "progress-cirlce-box"
    }, /*#__PURE__*/React.createElement(ProgressCircle, null), /*#__PURE__*/React.createElement("div", {
      className: "progress-check"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      style: {
        color: '#2ED47A'
      }
    }, "check"))), this.props.message ? /*#__PURE__*/React.createElement("div", {
      className: "margin-top two"
    }, this.props.message) : /*#__PURE__*/React.createElement("div", {
      className: "margin-top two"
    }, this.props.children), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}